module.exports = __webpack_public_path__ + "static/media/home.257e620c.mp4";